// extracted by mini-css-extract-plugin
export default {"image-container":"image-container--mp-Cmokx","imageContainer":"image-container--mp-Cmokx"};